import axios, {AxiosRequestConfig, AxiosResponse} from "axios"
import {authenticate, getAuthHeader} from "@/data/api/auth"
import appConfig from "@/config"

export const api = axios.create({
  baseURL: appConfig.BASE_API_URL,
  headers: {},
})

api.interceptors.request.use((r: AxiosRequestConfig): AxiosRequestConfig => {
  r.baseURL = appConfig.BASE_API_URL
  r.headers.Authorization = getAuthHeader()
  return r
})

api.interceptors.response.use((response: AxiosResponse<any>): AxiosResponse<any> => {
  return response
}, (err) => {
  if (err && err.response) {
    if (err.response.status === 401) {
      authenticate()
    } else if (err.response.status > 499 && err.response.status < 600) {
      if (err.response.data.errorMessage !== undefined) {
        console.error("mac request failed:", err.response.data.errorMessage)
      } else {
        console.error("mac request failed", err.response.statusText)
      }
    }
  }
  return Promise.reject(err)
})
